/*
 * Funzione di appoggio per la gestione delle date
 */

// converte una data nel formato gg/mm/aaaa per
// la rappresentazione a video
function convertDateToText(inputFormat) {
    function pad(s) { return (s < 10) ? `0${s}` : s; }
    const d = new Date(inputFormat);
    return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
}

// prende una data, rimuove tutta la parte ora/timezone
// e la converte in utc per facilitare il confronto
// tra date senza considerare ora e timezone
function convertDateToUtc(data) {
    // leggendo le date tramite get... senza utc, otteniamo esattamente
    // la parte numerica senza aggiustamente dovuto al timezone
    return Date.UTC(data.getFullYear(), data.getMonth(), data.getDate());
}

// controlla se la data di inizio validità rispetta le regole di convalida
export const isDataInizioValiditaValida = (minDataCanonica, maxDataCanonica, dataInizio) => {
    const validations = validaDataInizioValidita(minDataCanonica, maxDataCanonica, dataInizio);
    return validations && validations.length == 0;
};

// controlla se la data di fine validità rispetta le regole di convalida
export const isDataFineValiditaValida = (minDataCanonica, maxDataCanonica, dataInizio, dataFine) => {
    const validations = validaDataFineValidita(minDataCanonica, maxDataCanonica, dataInizio, dataFine);
    return validations && validations.length == 0;
};

// imposta le regole di validazione di un datepicker in cui inserire la data di inizio validità
// in base allo stato, attiva le regole di convalida opportune
// in modo cha appaia sempre e solo max 1 messaggio (quello più opportuno)
// in caso non ci siano errori, non deve
export const validaDataInizioValidita = (minDataCanonica, maxDataCanonica, dataInizio) => {
    let validations = [];

    if (!minDataCanonica || !maxDataCanonica || !dataInizio) {
        validations.push('required');
    } else {
        const currentDataInizio = new Date(dataInizio);
        const currentMinDataCanonica = new Date(minDataCanonica);
        const currentMaxDataCanonica = new Date(maxDataCanonica);

        // non può superare la data max canonica per l'anno anf
        if (convertDateToUtc(currentDataInizio) > convertDateToUtc(currentMaxDataCanonica)) {
            validations = ['required', {
                rule: 'Range', minValue: currentMinDataCanonica, maxValue: currentMaxDataCanonica, message: `Data successiva a ${convertDateToText(currentMaxDataCanonica)}`,
            }];
        } else if (convertDateToUtc(currentDataInizio) < convertDateToUtc(currentMinDataCanonica)) {
            // non può essere inferiore alla data min canonica per l'anno anf
            validations = ['required', {
                rule: 'Range', minValue: currentMinDataCanonica, maxValue: currentMaxDataCanonica, message: `Data antecedente a ${convertDateToText(currentMinDataCanonica)}`,
            }];
            // } else {
            //   // sempre obbligatorio
            //   validations.push('required');
        }
        // il controllo dataInizio < dataFine lo facciamo solo su 1 campo: quello di fine
    }

    return validations;
};

// imposta le regole di validazione di un datepicker in cui inserire la data di fine validità
// in base allo stato, attiva le regole di convalida opportune
// in modo cha appaia sempre e solo max 1 messaggio (quello più opportuno)
export const validaDataFineValidita = (minDataCanonica, maxDataCanonica, dataInizio, dataFine) => {
    let validations = [];

    if (!maxDataCanonica || !dataFine) {
        validations.push('required');
    } else {
        const currentDataFine = new Date(dataFine);
        const currentMaxDataCanonica = new Date(maxDataCanonica);
        const currentMinDataCanonica = new Date(minDataCanonica);

        // non può superare la data max canonica per l'anno anf (a prescidere che ci sia o meno la data minima!)
        if (convertDateToUtc(currentDataFine) > convertDateToUtc(currentMaxDataCanonica)) {
            validations = ['required', {
                rule: 'Range', minValue: currentMinDataCanonica, maxValue: currentMaxDataCanonica, message: `Data successiva a ${convertDateToText(currentMaxDataCanonica)}`,
            }];
        } else {
            // controllo data minima
            if (!minDataCanonica || !dataInizio) {
                validations.push('required');
            } else {
                const currentDataInizio = new Date(dataInizio);
                if (dataInizio && convertDateToUtc(currentDataFine) < convertDateToUtc(currentDataInizio)) {
                    // non può essere inferiore alla data minima di validità
                    // di conseguenza non serve il controllo sulla data minima canonica
                    validations = ['required', {
                        rule: 'Range', minValue: currentDataInizio, maxValue: currentMaxDataCanonica, message: 'Data antecedente all\'inizio validità',
                    }];
                }
            }
        }
    };
    return validations;
}